import { MutationList } from './mutation-list'
import {MutationTree} from "vuex";
import {userObject, appointment, user} from "@/store/types";

export type Mutations<S = userObject> = {
    [MutationList.SET_USER](state: S, payload: userObject): void;
    [MutationList.UNSET_USER](state: S): void;
    [MutationList.CHANGE_USER_NAME](state: S, payload: string): void;
    [MutationList.CHANGE_USER_SURNAME](state: S, payload: string): void;
    [MutationList.SAVE_APPOINTMENT_TO_USER](state: S, payload: appointment): void;
    /* eslint-disable-next-line */
    [MutationList.DELETE_APPOINTMENT_FROM_USER](state: S, payload: {user: number, appointment: number}): void;
    [MutationList.SAVE_TOKEN](state: S, payload: string): void;
    [MutationList.SET_AUTHENTICATED_TO_TRUE](state: S): void;
    [MutationList.SAVE_NEW_RELATIVE](state: S, payload: user): void;
    /* eslint-disable-next-line */
    [MutationList.SAVE_APPOINTMENT_TO_RELATIVE](state: S, payload: {user: number, appointment: appointment}): void;
    /* eslint-disable-next-line */
    [MutationList.DELETE_APPOINTMENT_FROM_RELATIVE](state: S, payload: {user: number, appointment: number}): void;
    [MutationList.SET_RELATIVES](state: S, payload: user[]): void;
}

export const mutations: MutationTree<userObject> & Mutations = {
    [MutationList.SET_USER](state, payload) {
        state.name = payload.name;
        state.token = payload.token;
        state.address = payload.address;
        state.surname = payload.surname;
        state.relatives = payload.relatives;
        state.authenticated = true;
    },
    [MutationList.UNSET_USER](state) {
        state.name = '';
        state.token = '';
        state.address = '';
        state.surname = '';
        state.relatives = [];
        state.authenticated = false;
    },
    [MutationList.CHANGE_USER_NAME] (state, payload) {
        state.name= payload;
    },
    [MutationList.CHANGE_USER_SURNAME] (state, payload) {
        state.surname= payload;
    },
    [MutationList.SAVE_APPOINTMENT_TO_RELATIVE](state, payload) {
        state.relatives[payload.user].appointments?.push(payload.appointment);
    },
    [MutationList.DELETE_APPOINTMENT_FROM_RELATIVE](state, payload) {
        state.relatives[payload.user].appointments?.splice(payload.appointment, 1)
    },
    [MutationList.SAVE_APPOINTMENT_TO_USER](state, payload) {
        state.appointments.push(payload);
    },
    [MutationList.DELETE_APPOINTMENT_FROM_USER](state, payload) {
        state.appointments.splice(payload.appointment, 1);
    },
    [MutationList.SAVE_TOKEN](state, payload){
        state.token = payload;
    },
    [MutationList.SET_AUTHENTICATED_TO_TRUE](state){
        state.authenticated = true;
    },
    [MutationList.SAVE_NEW_RELATIVE](state, payload) {
        state.relatives.push(payload);
    },
    [MutationList.SET_RELATIVES](state, payload) {
        state.relatives = payload;
    }
}